import { getData as apiGetData } from 'api/Api'
import { mapActivityData } from 'utils/activities'
import {
  addArray as addActivitiesArray,
  setLoadStatus,
  setLastLoadedId
} from '../redux/activities'

type Payload = {
  boardId: number
}

type ActivitiesArgs = {
  tagName: string
  olderThanId?: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { boardId } = payload

  const state = getState()
  
  if (state['view-board'].activities[boardId].isLoading) return

  dispatch(setLoadStatus({
    boardId,
    isLoading: true,
    isLoaded: false,
  }))

  const lastLoadedId = state['view-board'].activities[boardId].lastLoadedId

  const args: ActivitiesArgs = {
    tagName: 'board-' + boardId
  }

  if (lastLoadedId) {
    args.olderThanId = lastLoadedId
  }

  try {
    const { Activities } = await apiGetData('Activities', args)

    const activities: any[] = []
    let newLastLoadedId = null

    Activities.forEach(Activity => {
      const activity = mapActivityData(Activity)

      activities.push(activity)

      if (lastLoadedId === null || lastLoadedId > activity.id) {
        newLastLoadedId = activity.id
      }
    })

    const batchedActions: any[] = [
      addActivitiesArray({
        boardId,
        array: activities,
      }),
      setLoadStatus({
        boardId,
        isLoading: false,
        isLoaded: Activities.length < 20
      })
    ]

    if (newLastLoadedId !== null) {
      batchedActions.push(setLastLoadedId({
        boardId,
        lastLoadedId: newLastLoadedId,
      }))
    }

    dispatch(batchedActions)
  } catch (error) {
    dispatch(setLoadStatus({
      boardId,
      isLoading: false,
      isLoaded: false,
    }))
  }
}
